export const CURRENT_YEAR = new Date().getFullYear();
export const YEAR_BEFORE = CURRENT_YEAR - 1;
export const YEAR_2_BEFORE = CURRENT_YEAR - 2;
